'use strict';

var EditStaticRoutes = require('actionGroups/staticRoutes/StaticRoutes');

module.exports = {
  Model: EditStaticRoutes,
};
